<!-- Sidepanel-style Suggested Match Card -->
<div class="bg-grey suggested-match-card ng-star-inserted" 
     [class.selected]="selected"
     [class.unselected]="!selected && someCardSelected"
     (click)="onCardClick($event)"
     [attr.aria-selected]="selected"
     [attr.aria-label]="'Suggested match: ' + (match?.supplierName || match?.name || '') + (selected ? ' (Selected)' : '')"
     title="Click to select this match">
  <div class="col-sm-12 card-content">
    <div class="card-header">
      <div class="related-detail-wrap col-sm-9">
        <div class="supplier-row">
          <app-supplier-avatar class="sup_img_box sup_img_box_5 ng-star-inserted" [ngClass]="match?.hexColorClass"
            [ngStyle]="{ 'background-color': getBadgeColor() }"
            [supplierId]="match?.supplierId" [supplierName]="match?.supplierName || match?.name">
            <span>{{ getInitials(match?.supplierName || match?.name || '') }}</span>
          </app-supplier-avatar>
          <div class="sup_det">
            <div class="sd_name">
              <span class="name ng-star-inserted">{{ match?.supplierName || match?.name }}</span>
              <span class="selected-badge" *ngIf="selected">✓</span>
            </div>
            <div class="sd-mobile">
              <span class="sd_invoice invoice-number">{{ match?.date | date:'dd/MM/yy' }}</span>
              <span class="sd_invoice invoice-number ng-star-inserted">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ match?.accountName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3 match-amount-label ng-star-inserted"> {{ getAbsoluteAmount(match?.amount) | number:'1.2-2' }} </div>
    </div>
  </div>
</div>
